export default {
    namespaced: true,
    pbx_device: {
      title: "Device | Devices",
      name: "name",
      extension: "extension",
      password: "password",
      ha1: "HA1",
      dispatch_alarm: "dispatch alarm",
      ivr: "IVR",
    },
  };
  